"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CreateUpdateContactModel {
    static getAttributeTypeMap() {
        return CreateUpdateContactModel.attributeTypeMap;
    }
}
CreateUpdateContactModel.discriminator = undefined;
CreateUpdateContactModel.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "number"
    }
];
exports.CreateUpdateContactModel = CreateUpdateContactModel;
//# sourceMappingURL=createUpdateContactModel.js.map